import { translate } from '@openclassrooms/translations';

export const TITLE_STYLE = 'color: red; background: yellow; font-size: 24px;';
export const MESSAGE_STYLE = 'color: black; font-size: 18px;';
export const LINK_STYLE = 'color: black; font-style: italic; font-size: 12px;';

export default {
  warn(logger) {
    logger('%c%s', TITLE_STYLE, translate('global.warning.self_xss.title'));
    logger('%c%s', MESSAGE_STYLE, translate('global.warning.self_xss.message'));
    logger('%c%s', LINK_STYLE, translate('global.warning.self_xss.link'));
  },
};
